import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';
import { icons } from '../../../../../shared/icons';
import { useTranslation } from 'react-i18next';

const GridProvider = ({ data, handleOpenDialog, getEditData, isLoading }) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDialog(e.id)}
          getEditData={() => getEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    ...(localStorage.idFirme === '1'
      ? [
          {
            field: 'nazivKupca',
            headerName: t('client'),
            width: 250,
          },
        ]
      : []),
    // { field: 'nazivKupca', headerName: t('client'), width: 200 },
    { field: 'naziv', headerName: t('locationName'), width: 300 },
    { field: 'adresa', headerName: t('adress'), width: 400 },
    // { field: 'kontaktOsoba', headerName: 'Kontakt Osoba', width: 200 },
    // { field: 'kontaktTelefon', headerName: 'Kontakt Telefon', width: 150 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProvider;
